export var organizationLandingPageThemeTypeMap = {
  universal: {
    value: 'universal',
    label: 'Universal'
  },
  temporaryForWamo: {
    value: 'temporaryForWamo',
    label: 'Wamo'
  }
};
export var organizationLandingPageThemeTypeList = Object.values(organizationLandingPageThemeTypeMap);